import DataTable from "react-data-table-component";
import { PropagateLoader } from "react-spinners";
import NoData from "../../../../molecules/NoData";
import { useEffect, useState } from "react";
import { GET_USER_ROLE } from "../../../../../api/apiUsers";

const MantenimientoInmuebleTable = ({ data, refetch, loading}) => {
    const [loadingStaff, setLoadingStaff] = useState();
    const [staff, setStaff] = useState();

    useEffect(() => {
        const getStaff = async () => {
            try {
                setLoadingStaff(true);
                const staffData = await GET_USER_ROLE("Staff");
                setStaff(staffData);
            } catch (error) {
                console.error(error);
            } finally {
                setLoadingStaff(false);
            }
        };

        getStaff();
    }, []);

    const getName = (staffId) => {
        const staffName = staff?.find((person) => person.id === staffId);
        return staffName ? staffName.name : "Desconocido";
    };

    const columns = [
        {
            name: "Servicio",
            cell: (row) => (row.description)
        },
        {
            name: "Responsable",
            cell: (row) => (getName(row.staffId))
        },
        {
            name: "Fecha del servicio",
            cell: (row) => (
                <div>
                    <strong className={`${row.service_date ? "bg-green-500" : "bg-red-500"} rounded-md p-2 text-white font-bold`}> {row.date_service} </strong>
                </div>
        ),},
    ];

    return (
        <>
            <DataTable
                data={data}
                progressPending={loading || loadingStaff}
                columns={columns}
                progressComponent={ <div className="w-full h-20 flex justify-center items-center"> <PropagateLoader color="red" /> </div> }
                noDataComponent={<NoData />}
                pagination
            />
        </>
    );
};

export default MantenimientoInmuebleTable;